import {queries} from '@/shared/integrations/zero'
import {EventLog} from '@cypro/engine/schema'
import {type GetPageQuery, type GetSingleQuery} from '@cypro/ui/utils/zero-virtualizer'
import {useCallback, useMemo} from 'react'
import {type SystemLogStartRow} from './use-get-infinite-system-logs'

export function useGetInfinitePatientLogs({patientId, limit = 50}: {patientId: string; limit?: number}) {
  const listContextParams = useMemo(() => ({patientId, limit}), [patientId, limit])

  // @ts-expect-error schema type mismatch (works at runtime)
  const getPageQuery: GetPageQuery<EventLog, SystemLogStartRow> = useCallback(
    ({limit: pageLimit, start, dir}) => {
      const cursor =
        start?.id && start?.performedAt ? {id: start.id, direction: dir, performedAt: start.performedAt} : undefined

      return {
        query: queries.eventLogs.listPatientEvents({patientId, cursor, limit: pageLimit}),
      }
    },
    [patientId]
  )

  // @ts-expect-error schema type mismatch (works at runtime)
  const getSingleQuery: GetSingleQuery<EventLog> = useCallback(
    ({id}) => ({
      query: queries.eventLogs.getEventById(id),
    }),
    []
  )

  const toStartRow = useCallback(
    (row: EventLog): SystemLogStartRow => ({
      id: row.id,
      performedAt: row.performedAt,
    }),
    []
  )

  return {getPageQuery, getSingleQuery, toStartRow, listContextParams}
}
